import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { postAllData } from '../../../service/ProductService';
import { CASHBOOKDETAIL, DOWNLOADCASHBOOK } from '../../../config/ApiConstant';
import { CashBookDetailrReportListColumns } from '../../../appconfig/DatatableSetting';
import moment from 'moment';
import { amountFormate, downloadData, exportData } from '../../../appconfig/AppHelper';
import { amountCommonTemplate, amountTemplate, commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const CashBookDetailsReport = () => {
    document.title = 'Cash Book Detail | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [cashBookList, setCashBookList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);

    const [credit, setCredit] = useState<any>();
    const [debit, setDebit] = useState<any>();
    const [openingBalance, setOpeningBalance] = useState<any>();
    const [showButton, setShowButton] = useState<boolean>(false);

    // Date Object

    const storedDates = localStorage.getItem('cashbook_report');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'cashbook_report',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />
                <Button label="Show" onClick={() => getCashBookReportList()} loading={showLoading} className="ml-2"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-download" label="Download" onClick={() => downloadAllData()} className="mx-2" loading={loading} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //downloadDAta
    const downloadAllData = async () => {
        try {
            setLoading(true);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            // Request Data
            const requestData = {
                from_date: startDate,
                to_date: endDate
            };

            const response = await downloadData(DOWNLOADCASHBOOK, 'CashBook_Details_Report', requestData);
            if (response === true) {
                setLoading(false);
            } else if (response === false) {
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('CashBook_Details_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getCashBookReportListList
    const getCashBookReportList = async () => {
        try {
            setPageLoad(false);
            setShowLoading(true);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            // Request Data
            const requestData = {
                from_date: startDate,
                to_date: endDate
            };

            const response = await postAllData(CASHBOOKDETAIL, requestData);

            if (response) {
                setPageLoad(true);
                setShowLoading(false);
                setCashBookList(response?.data);
                setCredit(response?.credit);
                setDebit(response?.debit);
                setOpeningBalance(response?.obBalance);
                setShowButton(true);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setCashBookList([]);
                setShowLoading(false);
                setShowButton(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    const closingTemplate = (rowData: any) => {
          return <>{rowData?.closing}</>;
    };

    const finalTotal: any = !window.cn(openingBalance) || !window.cn(credit) || !window.cn(debit) ? Number(debit) - Number(credit) + Math.abs(Number(openingBalance)) : '';

    const finalOpeningBalance = !window.cn(openingBalance) ? Math.abs(Number(openingBalance)) : '';

    return (
        <>
            <AppBreadcrumb currentMenu={'Financial Reports'} pageName={'Cash Book Detail Report'} pageTitle={'Cash Book Detail Report'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={cashBookList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {CashBookDetailrReportListColumns.map((col: any, i: any) => {
                                        if (col.field === 'date') {
                                            return (
                                                <Column
                                                    key={col.field}
                                                    field={col.field}
                                                    header={col.header}
                                                    body={dateTemplate}
                                                    style={{ minWidth: '8rem' }}
                                                    footer={!window.cn(finalOpeningBalance) && 'Opening Balance:' + ' ' + finalOpeningBalance}
                                                />
                                            );
                                        } else if (col.field === 'credit') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountCommonTemplate} footer={!window.cn(debit) && debit} />;
                                        } else if (col.field === 'debit') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountCommonTemplate} footer={!window.cn(credit) && credit} />;
                                        } else if (col.field === 'closing') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={closingTemplate} footer={!window.cn(finalTotal) && 'Closing Balance:' + ' ' + finalTotal} />;
                                        } else if (col.field === 'message') {
                                            return <Column key={col.field} field={col.field} header={col.header}  />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {CashBookDetailrReportListColumns.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
